<template>
  <div class="certificate">
    <div v-if="info.list.length > 0">
      <table class="tab" border="1" cellspacing="0">
        <tr>
          <td>姓名</td>
          <td>证书</td>
        </tr>
        <tr v-for="(item, index) in info.list" :key="index">
          <td>{{ item.name }}</td>
          <td>
            <span class="but" @click="seeImg(item.certUrl)">查看证书</span>
          </td>
        </tr>
      </table>
      <button class="butStyle" @click="seeImg(info.url)">下载团体证书</button>
      <button class="butStyle" @click.stop="showAddressInp = true">
        申请纸质证书
      </button>
    </div>
    <div v-if="info.list.length <= 0">暂无证书信息</div>
    <van-image-preview v-model="show" :images="images" @click="show = false">
      <template #cover>
        <div class="apply-ccie-btn" v-if="canApply">
          <van-button
            :disabled="!isAudit"
            size="large"
            @click.stop="showAddressInp = true"
            color="linear-gradient(to right, #5DD682, #5AFF8E)"
            >申请纸质证书</van-button
          >
        </div>
        <div class="pre-close" style="text-align: right">
          <van-icon
            @click.stop="show = false"
            name="close"
            :style="{
              margin: '10px',
              fontSize: '24px',
              color: '#fff',
              position: 'fixed',
              left: '10px',
              right: '10px'
            }"
          />
        </div>
      </template>
    </van-image-preview>
    <van-dialog
      v-model="showAddressInp"
      show-cancel-button
      @confirm="(showAddressInp = false), (show = false)"
      @cancel="(showAddressInp = false), (show = false)"
    >
      <p style="padding: 10px 20px">
        {{ info.info }}
      </p>
    </van-dialog>
  </div>
</template>

<script>
import { getGroupCertUrl } from "@/utils/api/user";
export default {
  components: {},
  data() {
    return {
      show: false,
      images: [],
      canApply: false,
      showAddressInp: false,
      id: "",
      info: {
        list: []
      }
    };
  },
  methods: {
    seeImg(url) {
      this.show = true;
      this.images = [url];
      this.canApply = false;
    },
    getCertificateInfo() {
      getGroupCertUrl(this.id).then((res) => {
        if (res.success) {
          this.info = res.data;
        }
      });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getCertificateInfo();
  }
};
</script>

<style lang="scss" scoped>
.certificate {
  padding: 80px 40px;
  .tab {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-color: #eee;
    td {
      padding: 10px;
      font-size: 16px;
    }
    .but {
      color: #10b70f;
    }
  }
  .butStyle {
    background-color: #10b70f;
    border: 0px;
    height: 40px;
    border-radius: 20px;
    margin-top: 20px;
    color: #fff;
    width: 200px;
    font-size: 14px;
  }
}
</style>
